export function getLocalStorageItem(key: string): string | null {
    try {
        return localStorage.getItem(key);
    } catch (error) {
        return null;
    }
}
